<div id="bottom-navigation" class="md:hidden flex justify-center border-0 border-t border-b border-l-0 border-r-0
  rounded-none  border-gray-200 grid grid-cols-4 items-center p-0 text-center text-xs max-w-max-max">
 <a routerLink="/dashboard"><div class="border-r-1 border-gray-200 bottom-nav-element">
    <div id="dashboard-menu-icon" class="bottom-nav-icon"></div>
    Dashboard
  </div>
  </a>
  <a routerLink="/energy-chart"><div class="border-r-1 border-gray-200 bottom-nav-element">
    <div id="performance-menu-icon" class="bottom-nav-icon"></div>
    Performance
  </div>
  </a>
  <div class="border-r-1 border-gray-200 bottom-nav-element">
    <div class="bottom-nav-icon" id="schedule-menu-icon"></div>
    Fahrplan
  </div>
  <div class="border-r-1 border-gray-200 bottom-nav-element">
    <div class="bottom-nav-icon" id="settings-menu-icon"></div>
    Einstellungen
  </div>
</div>
